import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import DashboardView from '../views/DashboardView.vue'
import SettingsView from '../views/SettingsView.vue'
import MicrosoftView from '../views/MicrosoftView.vue'
import PpolicyView from '../views/PpolicyView.vue'
import Swal from 'sweetalert2';
import store from '@/store'
import 'tw-elements';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    beforeEnter: (to, from, next) => {
      if ( store.getters['authenticated'] ){
          next('/dashboard');
      } else {
          next();
      }
    }
  },
  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    beforeEnter: (to, from, next) => {
      if ( !store.getters['authenticated'] ){
          next('/');
      } else {
          next();
      }
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    beforeEnter: (to, from, next) => {
      if ( !store.getters['authenticated'] ){
          next('/');
      } else {
          next();
      }
    }
  },
  {
    path: '/favorites',
    name: 'favorites',
    component: () => import('../views/FavoritesView.vue'),
    beforeEnter: (to, from, next) => {
      if ( !store.getters['authenticated'] ){
          next('/');
      } else {
          next();
      }
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PpolicyView,
    beforeEnter: (to, from, next) => {
          next();
    }
  },

  {
    path: '/microsoftcallback',
    name: 'microsoftcallback',
    component: MicrosoftView,
    beforeEnter: () => {

    }
  },

  // For redirection when clicking a tile link
  // Sample link = https://tap.cloudstaff.com/tile/:uuid

  {
    path: '/tile/:uuid',
    name: 'tileRedirect',
    beforeEnter: (to, from, next) => {

      if ( store.getters['authenticated'] === false ){
          Swal.fire({
            title: 'Access Denied',
            text: 'You must be logged in to access this tile.',
            icon: 'warning',
            confirmButtonText: 'OK',
            customClass: {
                confirmButton: 'px-6 py-2 text-white bg-red-600 rounded-lg hover:bg-red-900 mx-2 my-2 border border-blue-600'
            },
            allowOutsideClick: false,
          });

          next('/');
      }

      next({
        name: 'dashboard',
        query: { entrytile: to.params.uuid }
      });
    }

  },
  

  // For redirection when scanning a QR code in phones and the Tap mobile app
  // is not installed. 
  // Sample QR = https://tap.cloudstaff.com/mobile?guid=abc123
  {
    path: '/mobile',
    name: 'mobile',
    beforeEnter: (to, from, next) => {
      const userAgent = navigator.userAgent.toLowerCase();
      const playstoreUrl = 'https://play.google.com/store/apps/details?id=com.cloudstaff.tap3';
      const appstoreUrl = 'https://apps.apple.com/app/cloudstaff-tap/id1434496444';

      if (userAgent.indexOf("android") > -1) {
        window.location.href = playstoreUrl;
      } else if (userAgent.indexOf("iphone") > -1) {
        window.location.href = appstoreUrl;
      } else {
        var redirectUrl = store.getters['authenticated'] ? '/' : '/dashboard';
        next(redirectUrl);
      }
    }
  }


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


export default router
